import { Component, HostListener } from '@angular/core';
import { UserNotification } from '../models/usernotification';
import { EventBusService, EventType, ATMEventData } from '../services/eventbus.service';
import { DataService } from '../services/data.service';
import { TrackAuthority } from '../models/trackauthority';
import { Status } from '../models/status.enum';
import { Source } from '../models/source.enum';
import { SANotificatonsStatus } from '../models/sa-notifications.enum';
import { AppConstant } from '../common/app.constant';
import { SystemStatusService } from '../services/systemstatus.service';

@Component({
  selector: 'user-notification',
  templateUrl: './usernotification.component.html',
  styleUrls: ['./usernotification.component.scss']
})
export class UserNotificationComponent {
  isSmallScreen: boolean = false;
  showAll: boolean = false;
  visible: boolean = false;
  notificationList: UserNotification[] = new Array<UserNotification>();
  requestTimer: any;
  newNotificationCount: number = 0;
  authorityForUserConfirmation: TrackAuthority = null;
  actionForUserConfirmation: Source = null;

  constructor(private dataService: DataService, private eventBus: EventBusService, private _systemStatusService: SystemStatusService) {
    this.eventBus.getEventBus(EventType.NOTIFICATION_POLL_EVENT).subscribe(response => {
      this.updateNotificationList(response.data);
    });
  }

  get systemState(): SystemStatusService {
    return this._systemStatusService;
  }

  @HostListener('mouseout') onMouseOut() {
    this.beforeClose();
  }

  private beforeClose(): void {
    clearTimeout(this.requestTimer);
    if (this.visible) {
      this.requestTimer = setTimeout(() => this.onClose(), 750);
    }
  }

  @HostListener('mouseover') onMouseOver() {
    clearTimeout(this.requestTimer);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isSmallScreen = event.target.innerWidth < 700;
  }

  onClose(): void {
    let notificationIdList: number[];
    if (this.showAll || this.isSmallScreen) {
      notificationIdList = this.getUnreadIds();
    } else {
      notificationIdList = this.getUnreadIds().slice(0, 3);
    }
    this.dismissNotifications(notificationIdList);
    this.markAsRead(notificationIdList);
    this.visible = false;
    this.showAll = false;
  }

  dismissNotifications(notificationIdList: number[]): void {
    if (notificationIdList.length > 0) {
      this.dataService.setUserNotificationAcknowledgement(notificationIdList);
    }
  }

  showAllElements(): void {
    this.showAll = !this.showAll;
  }

  showNotifications(): void {
    this.visible = !this.visible;
  }

  private markAsRead(notificationIdList: number[]): void {
    notificationIdList.forEach(id => (this.notificationList.find(item => item.id === id).read = true));
    this.newNotificationCount = this.getUnreadIds().length;
  }

  private getUnreadIds(): number[] {
    return this.notificationList.filter(element => !element.read).map(element => element.id);
  }

  private updateNotificationList(notifications: Array<any>): void {
    notifications.reverse().forEach((userNotification,index) => {
      let notification: UserNotification = this.notificationList.find(item => item.id === userNotification.id);
      if (notification === undefined) {
        this.notificationList.splice(index, 0, userNotification);
      } else {
        if (!userNotification.read) {
          notification.read = false;
        }
      }
    });
    this.notificationList = this.notificationList.filter(item => notifications.find(element => element.id === item.id) !== undefined);
    this.newNotificationCount = this.getUnreadIds().length;
  }

  openClickableNotification(item: UserNotification): void {
    if (item.messageHeading.trim() === SANotificatonsStatus.REJ_MOD) {
      this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_REJECTED_MODIFICATION, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.AS) {
      this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_SHARED, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.RA) {
      this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_RELEASED, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.SR) {
      this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_SHARE_REQUEST, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.AUTH_MOD) {
      this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_MODIFIED, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.ACC_MOD) {
        this.dataService.openSharedAuthorityModel(true, AppConstant.AUTHORITY_ACCEPTED_MODIFICATION, item);
    } else if (item.messageHeading.trim() === SANotificatonsStatus.TTP) {
      let trackAuthority = this.dataService.returnSharedAuthorityOnId(item.authorityId);
      if (!trackAuthority || !trackAuthority.ec1Number || trackAuthority.status === Status.RELEASED) {
        this.eventBus.fireEvent(
          EventType.NOTIFY_FAILURE_EVENT,
          new ATMEventData(null, () => {
            return AppConstant.EXPIRED_NOTIFICATION_TEXT;
          })
        );
        return;
      } else {
        this.actionForUserConfirmation = Source.TRANSFER_TO_PAPER;
        this.authorityForUserConfirmation = trackAuthority;
      }
    }
  }

  userAccepted(trackAuthority: TrackAuthority): void {
    this.authorityForUserConfirmation = null;
    this.dataService.transferAuthority(trackAuthority, this.actionForUserConfirmation);
  }

  userCancelled(event: any): void {
    this.authorityForUserConfirmation = null;
    this.actionForUserConfirmation = null;
  }
}
